// extracted by mini-css-extract-plugin
export default {"color-tile":"BJ3ArdD","color-tile--disabled":"voyDZj_","color-tile--selected":"ezoYiyI","color-tile--tooltip":"NXRfXwD"};